// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Merkt sich je Konto, ob die Einführung schon gelaufen ist. Bewusst lokal:
// teilen sich zwei Leute ein Handy, soll jede ihre eigene Einführung bekommen —
// deshalb steht die Konto-id im Schlüssel.
import { pb } from "./pb"

const VERSION = 1

function schluessel(): string {
  return `fithub:einfuehrung:${pb.authStore.record?.id ?? "gast"}`
}

export function einfuehrungGesehen(): boolean {
  try { return Number(localStorage.getItem(schluessel())) >= VERSION } catch { return true }
}

export function einfuehrungMerken(): void {
  try { localStorage.setItem(schluessel(), String(VERSION)) } catch { /* nicht speicherbar — egal */ }
}

/** „Einführung nochmal ansehen" in den Optionen. */
export function einfuehrungZuruecksetzen(): void {
  try { localStorage.removeItem(schluessel()) } catch { /* egal */ }
}
